import api from 'apis/api';
import filterApiErr from 'apis/filterApiError';
import { Marketplace } from 'models/Marketplace';
import ERR_MSG from 'utils/errorMessage';

export const fetchMarketplaces = async () => {
  try {
    const resp = await api.get('/api/v1/marketplaces');
    const data = resp.data.marketplaces as Marketplace[];
    return Promise.resolve(data);
  } catch (_err: any) {
    let errMsg = '';

    const err = filterApiErr(_err);
    if (err) {
      errMsg = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
    }

    return Promise.reject(errMsg);
  }
};
